export default "__VITE_ASSET__DIByRJfF__"